import React, { FC } from 'react'

import theme from '@app/theme'
import { AppIcon } from '@app/components/AppIcon'
import DeleteModuleFormBody from './DeleteModuleFormBody'
import AppContextModal from '@app/components/AppModal/AppContextModal'

const buttonStyles = {
    justifyContent: 'flex-start',
    width: '100%',
    height: '2.344rem',
    '& .MuiButton-startIcon': {
        mr: 2.7,
    },
    px: 4,
    fontFamily: 'Gilroy-Medium, sans-serif',
    background: theme.palette.primary.contrastText,
    color: theme.palette.text.primary,
    fontSize: '0.9375rem',
    fontWeight: 400,
}

interface DeleteModuleFormProps {
  isLoading: boolean
  handleDeleteContent: () => Promise<void>
}

const DeleteModuleForm: FC<DeleteModuleFormProps> = ({
  isLoading,
  handleDeleteContent,
}: DeleteModuleFormProps) => {
  return (
    <AppContextModal
        title={'Delete module'}
        buttonVariant='text'
        buttonColor='primary'
        openModalButtonText={'Delete'}
        width={'39rem'}
        fullWidth
        startIcon={<AppIcon type={'trash'} />}
        openButtonSx={{
            ...buttonStyles
        }}
    >
        <DeleteModuleFormBody
            handleDeleteContent={handleDeleteContent}
            isLoading={isLoading}
        />
    </AppContextModal>
  )
}

export default DeleteModuleForm
